<!--
 * @Descripttion:
 * @version:
 * @Author: 杨海波
 * @Date: 2021-07-29 16:11:25
 * @LastEditors: 杨海波
 * @LastEditTime: 2021-12-08 14:27:51
 * @FilePath: /intell-loan/src/views/pages/publicPage/Perfect/components/common/Input.vue
-->
<template>
  <div class="inputShell" :class="notemr ? '' : 'temr' ">
    <div class="inputBox">
      <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
      <div class="inputItem">
        <input
          class="inputContainer"
          :readonly="params.disabled"
          :placeholder="params.props.placeholder"
          :maxLength="params.props.maxLength"
          @input="changeInput"
          v-model="value"
          type="text"
        />
        <div class="error" :style="{ color: 'red' }" v-if="error && value !== ''">{{ error }}</div>
      </div>
    </div>
    <van-icon v-if="!params.disabled && allowClearHandler && value" @click="allowClear" class="cross" name="cross" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'Input',
  data() {
    return {
      value: '',
      error: '',
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form', 'notemr'],
  methods: {
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      if (this.params.field === 'taxNo' || this.params.field === 'borrowerIdentity' || this.params.field === 'iceContactIdentity') {
        this.value = val.target.value.toUpperCase();
      } else {
        this.value = val.target.value;
      }
    },
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  watch: {
    // 如果已经实名认证了，就将姓名、身份证号输入框禁用
    'publicPage.personAuthStatus': {
      handler(n) {
        if (n) {
          this.form.dispatch({
            type: 'upDateupDisabled',
            borrowerName: true,
          });
          this.form.dispatch({
            type: 'upDateupDisabled',
            borrowerIdentity: true,
          });
        }
      },
      immediate: true,
    },
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  padding: 0;
}
>>> input:disabled {
  background: #fff;
}
.allowClear {
  font-size: 14px;
  color: #999;
}
input{
  flex: 1;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -11px;
    }
  }
}
.error {
  font-size: 12px;
}

.inputShell input::placeholder {
  color: #bcc2cc;
  font-size: 16px;
}

.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
.title {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #46494D;
  line-height: 21px;
  font-weight: 400;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  width: 86px;
  margin-right: 16px;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.cross {
  position: absolute;
  right: 16px;
  color: #9e9fa0;
}
</style>
